export const CopyrightFooter = ({ className = "" }) => (
  <footer className={`text-center py-3 px-4 ${className}`} data-testid="copyright-footer">
    <p className="text-[9px] leading-relaxed text-muted-foreground/60">
      &copy; Copyright 2026 | <span className="font-medium">86BIT srl Unipersonale</span> &mdash; Codice Fiscale e P.Iva 04353030168 &mdash; Capitale sociale &euro; 30.000,00 i.v. &mdash; Reg. Imprese di Bergamo 04353030168
    </p>
    <p className="text-[9px] leading-relaxed text-muted-foreground/60">
      REA n. BG456578 &mdash; Sede Operativa: Piazza Papa Giovanni XXIII &mdash; 24020 Scanzorosciate (BG) &mdash; Tel. +39 035 310 900 &mdash; info@86bit.it
    </p>
  </footer>
);
